import Ride from 'common/types/Ride';
import {updateRide} from 'ondemand/actions/ride';

export const REQUEST_RIDE_DETAILS = 'REQUEST_RIDE_DETAILS';

export function requestRideDetails() {
  return {type: REQUEST_RIDE_DETAILS};
}

export const RECEIVE_RIDE_DETAILS = 'RECEIVE_RIDE_DETAILS';

export function receiveRideDetails(agencyId, rideId, rideDetails) {
  return {type: RECEIVE_RIDE_DETAILS, agencyId, rideId, rideDetails};
}

export const CLEAR_RIDE_DETAILS = 'CLEAR_RIDE_DETAILS';

export function clearRideDetails() {
  return {type: CLEAR_RIDE_DETAILS};
}

export const SET_RIDE_DETAILS_TIMEOUT = 'SET_RIDE_DETAILS_TIMEOUT';

export function setRideDetailsTimeout(timeout) {
  return {type: SET_RIDE_DETAILS_TIMEOUT, timeout};
}

export const UNSET_RIDE_DETAILS_TIMEOUT = 'UNSET_RIDE_DETAILS_TIMEOUT';

export function unsetRideDetailsTimeout() {
  return {type: UNSET_RIDE_DETAILS_TIMEOUT};
}

export function clearRideDetailsTimeout(timeout) {
  return dispatch => {
    clearTimeout(timeout);
    dispatch(unsetRideDetailsTimeout(timeout));
  };
}

export function fetchRideDetails(agencyId, rideId) {
  return (dispatch, getState, {api}) => {
    dispatch(requestRideDetails());
    return api.fetchRideDetails({agencyId, rideId, state: getState()}).then(response => {
      switch (response.status) {
        case 200:
          return response
            .json()
            .then(json => new Ride(json))
            .then(rideDetails => {
              dispatch(updateRide(rideDetails));
              return dispatch(receiveRideDetails(agencyId, rideId, rideDetails));
            });
        case 400:
          return response.json();
        default:
          throw response;
      }
    });
  };
}

export function pollRideDetails(agencyId, rideId) {
  return (dispatch, getState) => {
    const {timeout} = getState().rideDetails;
    if (timeout !== null) {
      dispatch(clearRideDetailsTimeout(timeout));
    }
    dispatch(fetchRideDetails(agencyId, rideId)).then(() => {
      dispatch(
        setRideDetailsTimeout(
          setTimeout(
            () => {
              dispatch(pollRideDetails(agencyId, rideId));
            },
            5000,
          ),
        ),
      );
    });
  };
}

export function cancelRideDetails() {
  return (dispatch, getState) => {
    const {timeout} = getState().rideDetails;
    if (timeout !== null) {
      dispatch(clearRideDetailsTimeout(timeout));
    }
  };
}



// WEBPACK FOOTER //
// ./src/ondemand/actions/rideDetails.js